<button
  type="button"
  [bitMenuTriggerFor]="notificationsMenu"
  [attr.aria-label]="'notifications' | i18n"
  class="tw-relative tw-flex tw-size-9 tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-solid tw-border-border-subtle tw-bg-background tw-text-main tw-transition hover:tw-bg-background-alt hover:tw-text-primary focus:tw-outline-none"
>
  <i class="bwi bwi-bell tw-text-lg" aria-hidden="true"></i>
  @if (pendingInvitations().length > 0) {
    <span
      class="tw-absolute -tw-top-1.5 -tw-right-1.5 tw-flex tw-min-w-[20px] tw-h-5 tw-items-center tw-justify-center tw-rounded-full tw-bg-[#ef4444] tw-px-1 tw-text-[11px] tw-font-bold tw-text-white tw-shadow-sm"
    >
      {{ pendingInvitations().length > 99 ? '99+' : pendingInvitations().length }}
    </span>
  }
</button>

<bit-menu #notificationsMenu>
  <div class="tw-flex tw-w-80 sm:tw-w-96 tw-flex-col tw-p-3">
    <div class="tw-flex tw-items-center tw-justify-between tw-border-b tw-border-solid tw-border-border-subtle tw-pb-2.5 tw-mb-2">
      <div class="tw-flex tw-items-center tw-gap-2">
        <i class="bwi bwi-bell tw-text-primary" aria-hidden="true"></i>
        <span class="tw-font-bold tw-text-sm tw-text-main">{{ "notifications" | i18n }}</span>
      </div>
      @if (pendingInvitations().length > 0) {
        <span class="tw-rounded-full tw-bg-[#ef4444] tw-px-2 tw-py-0.5 tw-text-[11px] tw-font-bold tw-text-white">
          {{ pendingInvitations().length }}
        </span>
      }
    </div>

    @if (pendingInvitations().length === 0) {
      <div class="tw-py-6 tw-text-center tw-text-muted">
        <i class="bwi bwi-bell tw-text-3xl tw-mb-2 tw-block tw-opacity-40" aria-hidden="true"></i>
        <p class="tw-text-sm tw-mb-0">{{ "noNotifications" | i18n }}</p>
      </div>
    } @else {
      <div class="tw-flex tw-flex-col tw-gap-2.5 tw-max-h-80 tw-overflow-y-auto tw-py-1">
        @for (invitation of pendingInvitations(); track invitation.organizationUserId) {
          <div class="tw-flex tw-flex-col tw-gap-2 tw-rounded-xl tw-border tw-border-solid tw-border-border-subtle tw-bg-background-alt tw-p-3.5 tw-transition hover:tw-border-primary/40">
            <div class="tw-flex tw-items-start tw-gap-3">
              <div class="tw-flex tw-size-8 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-lg tw-bg-primary/10 tw-text-primary">
                <i class="bwi bwi-briefcase tw-text-base" aria-hidden="true"></i>
              </div>
              <div class="tw-flex-1 tw-min-w-0">
                <p class="tw-font-semibold tw-text-xs tw-text-main tw-mb-0.5">{{ "pendingOrganizationInvitation" | i18n }}</p>
                <p class="tw-text-xs tw-text-muted tw-mb-0">
                  {{ "pendingOrganizationInvitationDesc" | i18n: invitation.organizationName }}
                </p>
              </div>
            </div>
            <div class="tw-flex tw-justify-end tw-mt-1">
              <button
                bitButton
                type="button"
                buttonType="primary"
                size="small"
                [disabled]="acceptingInvitationId() === invitation.organizationUserId"
                (click)="acceptInvitation(invitation)"
                class="tw-rounded-lg tw-font-medium !tw-bg-[#0062ff] hover:!tw-bg-[#0052cc]"
              >
                {{ "acceptInvitation" | i18n }}
              </button>
            </div>
          </div>
        }
      </div>
    }
  </div>
</bit-menu>
